function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C6C9DC9E-E4E6-4FA3-BD6B-DD58BF86FC52");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "DMA-Dashboards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "DMA-3---1920x1080",
  transform: "translate(-1826.000000, -413.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Cards",
  transform: "translate(308.000000, 384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layout-v1",
  transform: "translate(16.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/card-expand",
  transform: "translate(1502.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6931893,11.2159293 L19.7142857,5.19483294 L19.7142857,7.66071429 C19.7142857,7.9269758 19.9301671,8.14285714 20.1964286,8.14285714 L20.5178571,8.14285714 C20.7841187,8.14285714 21,7.9269758 21,7.66071429 L21,3.48214286 C21,3.21588135 20.7841187,3 20.5178571,3 L16.3392857,3 C16.0730242,3 15.8571429,3.21588135 15.8571429,3.48214286 L15.8571429,3.80357143 C15.8571429,4.06983294 16.0730242,4.28571429 16.3392857,4.28571429 L18.8051671,4.28571429 L12.7840707,10.3068107 C12.5958121,10.4950692 12.5958121,10.8003322 12.7840707,10.9886693 L13.0113307,11.2159293 C13.1996286,11.4041879 13.5048915,11.4041879 13.6931893,11.2159293 Z M7.66071429,21 C7.9269758,21 8.14285714,20.7841187 8.14285714,20.5178571 L8.14285714,20.1964286 C8.14285714,19.9301671 7.9269758,19.7142857 7.66071429,19.7142857 L5.19483294,19.7142857 L11.2159293,13.6931893 C11.4041879,13.5048915 11.4041879,13.1996286 11.2159293,13.0113307 L10.9886693,12.7840707 C10.8003714,12.5957729 10.4951085,12.5957729 10.3068107,12.7840707 L4.28571429,18.8051671 L4.28571429,16.3392857 C4.28571429,16.0730242 4.06983294,15.8571429 3.80357143,15.8571429 L3.48214286,15.8571429 C3.21588135,15.8571429 3,16.0730242 3,16.3392857 L3,20.5178571 C3,20.7841187 3.21588135,21 3.48214286,21 L7.66071429,21 Z",
  id: "expand",
  fill: "#8B9799",
  fillRule: "nonzero"
}))))));

var SvgIconCardExpand = function SvgIconCardExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCardExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_card-expand.7671526c.svg";
export { ForwardRef as ReactComponent };